/**
 * Shared copy and helpers for institution (school-day) payment.
 * Text must match AM-institution-payment-prototype.html.
 * Not AM-only: any BU with institution_payment_enabled uses these helpers.
 */

export function getPrototypeInstitutionTermsHtml(options = {}) {
  // A-6.2: order page strips the Draft badge; C-6 keeps the 6 refund policy items.
  const showDraftBadge = options.showDraftBadge === true
  const parts = []
  if (showDraftBadge) {
    parts.push('<div style="margin-bottom:9px"><span style="display:inline-block;background:#F1EFE8;border:1px solid #D3D1C7;color:#5F5E5A;font-size:11.5px;padding:2px 8px;border-radius:6px;">Draft — pending legal sign-off</span></div>')
  }
  parts.push(
    '<ol style="padding-left:20px;margin:0;">',
    '<li style="margin-bottom:9px;">The institution licence fee is charged once per institution, per program, per competition year.</li>',
    '<li style="margin-bottom:9px;">The licence covers students who register through the institution\'s paid registration link.</li>',
    '<li style="margin-bottom:9px;">The licence is activated only after the full fee is received in the beneficiary account.</li>',
    '<li style="margin-bottom:9px;">Where payment is made by international wire, all bank charges must be borne by the payer (OUR). Any shortfall remains payable before activation.</li>',
    '<li style="margin-bottom:9px;"><b>Refunds</b><ul style="margin:7px 0 0;padding-left:18px;list-style:disc;">',
    '<li style="margin-bottom:6px;"><b>Full refund</b> if requested at least <b>30 days</b> before the program\'s official start date, and no student has yet registered through your institution link.</li>',
    '<li style="margin-bottom:6px;"><b>50% refund</b> if requested at least <b>14 days</b> before the official start date, and no student has yet registered through your institution link.</li>',
    '<li style="margin-bottom:6px;"><b>No refund</b> within 14 days of the official start date, once any student has registered through your institution link, or once the program has begun.</li>',
    '<li style="margin-bottom:6px;"><b>Unused places are not refunded or carried forward.</b> Where your institution purchased a fixed number of places, places left unused — including after a student is removed from the roster — are not refundable.</li>',
    '<li style="margin-bottom:6px;"><b>Payment processing fees and bank charges are not refundable.</b> Card payments are refunded to the original card; bank transfers are refunded by bank transfer to the payer.</li>',
    '<li style="margin-bottom:6px;"><b>If we cancel or materially change the program, the fee is refunded in full.</b></li>',
    '</ul></li>',
    '<li style="margin-bottom:0;">Submission of payment constitutes acceptance of the EAE Integrity Policy and the program rules.</li>',
    '</ol>'
  )
  return parts.join('')
}

/** Institution order page T&C: prototype body without Draft badge (A-6.2 / C-6). */
export function getInstitutionOrderTermsHtml() {
  return getPrototypeInstitutionTermsHtml({ showDraftBadge: false })
}

export function resolveInstitutionTermsHtml(policy) {
  const text = policy && String(policy).trim() !== '' ? String(policy) : ''
  if (text) {
    return text.replace(/\r\n\r\n/g, '<br><br>')
  }
  return getPrototypeInstitutionTermsHtml({ showDraftBadge: true })
}

export function formatInstitutionMoney(amount) {
  return Number(amount || 0).toFixed(2)
}

export function calcInstitutionOrderAmounts({ standardFee, reduction = 0, serviceFee = 0, method = 'card' }) {
  const std = Math.max(0, Number(standardFee || 0))
  const red = Math.max(0, Number(reduction || 0))
  const after = Math.max(0, std - red)
  const svc = method === 'card' ? Math.max(0, Number(serviceFee || 0)) : 0
  return {
    std,
    red,
    after,
    svc,
    total: after + svc
  }
}

export const INSTITUTION_BANK = {
  beneficiary: 'EXTRACURRICULAR EXCELLENCE INT PTE. LTD.',
  account: '072-152241-1',
  bank: 'DBS Bank Ltd Singapore',
  swift: 'DBSSSGSG'
}
